import React from 'react';
import { InputLabel, MenuItem, Select } from '@material-ui/core';

/**
 * Parse options - handles both old string format and new object array format
 * @param {string|Array} options
 * @returns {Array} Array of option objects { label }
 */
function parseOptions(options) {
    if (!options) return [];
    if (Array.isArray(options)) {
        return options;
    }
    // Old format: comma-separated string
    return options
        .split(',')
        .map(opt => opt.trim())
        .filter(opt => opt)
        .map(label => ({ label }));
}

const BookingFieldSelect = ({ field, value, onChange, disabled }) => {
    const parsedOptions = parseOptions(field.options);

    // Handle backward compatibility: if value is a numeric index, convert to label
    let displayValue = value;
    if (typeof value === 'number' && parsedOptions[value]) {
        displayValue = parsedOptions[value].label;
    }

    return (
        <>
            <InputLabel htmlFor={`select-${field.id}`}>
                {field.name}
                {field.required ? '*' : ''}
            </InputLabel>
            <Select
                id={`select-${field.id}`}
                value={displayValue}
                onChange={onChange}
                inputProps={{
                    name: field.name,
                    id: `select-${field.id}`
                }}
                required={field.required}
                disabled={disabled}
            >
                {!field.required && <MenuItem value="">None</MenuItem>}
                {parsedOptions.map((option, key) => (
                    <MenuItem key={key} value={option.label}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </>
    );
};

export default BookingFieldSelect;
